import { useEffect } from 'react';
import { useStepController } from './StepControllerContext';
import { SetCurrentStepSubmissionArgsProps } from './RouterBasedStepper.types';

const useLayoutController = ({
    callbackOnContinue = undefined,
    isContinueDisabled = false,
    isContinueLoading = false,
    isBackDisabled = false,
    reSubscriptionStates = [],
    setPageErrors = undefined,
}: SetCurrentStepSubmissionArgsProps) => {
    const { setCurrentStepController, ...state } = useStepController();

    useEffect(() => {
        setCurrentStepController({
            callbackOnContinue,
            isContinueDisabled,
            isBackDisabled,
            isContinueLoading,
            setPageErrors,
        });

        return () => setCurrentStepController({
            callbackOnContinue: undefined,
            isContinueDisabled: false,
            isBackDisabled: false,
            isContinueLoading: false,
            reSubscriptionStates: [],
            setPageErrors: undefined,
        });
    }, [isContinueDisabled, isBackDisabled, isContinueLoading, ...reSubscriptionStates]);

    return {
        ...state,
    };
};

export default useLayoutController;
